import { Eyebrow } from '@/components/ui';
import { BarbellIcon, GridIcon, ShieldIcon, SparkIcon, UploadIcon, WatchIcon } from '@/lib/icons';

const PROBLEMS = [
  {
    problem: '“I lose my place in the spreadsheet mid-set.”',
    solution: 'The Grid keeps the exercise pinned, the set you are on highlighted, and the empty cell one tap away.',
    icon: <GridIcon className="text-lg" />,
  },
  {
    problem: '“My watch app wants my phone in my pocket.”',
    solution:
      'The watchOS companion logs a set with one tap, runs the rest timer on your wrist, and queues everything offline until the phone is back.',
    icon: <WatchIcon className="text-lg" />,
  },
  {
    problem: '“Nobody tells me what to lift next week.”',
    solution:
      'The AI Performance Coach reads your log, detects progressive overload, names fatigue, and writes the next block — with the reasoning attached.',
    icon: <SparkIcon className="text-lg" />,
  },
];

const CAPABILITIES = [
  {
    title: 'Upload the programme you already run',
    body: 'CSV, JSON or a template. Lift2Fit parses it, maps every movement to the exercise library, and shows it as a plan you can start today.',
    icon: <UploadIcon className="text-lg" />,
  },
  {
    title: 'One log, four screens',
    body: 'Web, iOS, Android and watchOS stay in sync within seconds. Conflicts resolve by idempotency key — no duplicated sets, ever.',
    icon: <BarbellIcon className="text-lg" />,
  },
  {
    title: 'Your data stays yours',
    body: 'Row-level security on every table means a query can only ever return your rows. Export everything as CSV or JSON whenever you like.',
    icon: <ShieldIcon className="text-lg" />,
  },
];

export function Features() {
  return (
    <section id="features" className="border-b border-hairline bg-page py-20">
      <div className="mx-auto max-w-[1200px] 2xl:max-w-[1440px] min-[1920px]:max-w-[1720px] px-4 sm:px-6">
        <div className="mb-12 flex flex-col gap-4">
          <Eyebrow>The problem, stated plainly</Eyebrow>
          <h2 className="font-display text-h2 font-black uppercase leading-tight tracking-[-0.01em] text-ink md:text-display-2">
            Three things every lifter says in week two.
          </h2>
        </div>

        <ul className="grid gap-6 md:grid-cols-3">
          {PROBLEMS.map((item) => (
            <li key={item.problem} className="flex flex-col gap-4 rounded-card border border-hairline bg-surface p-6 shadow-card">
              <span className="inline-flex h-10 w-10 items-center justify-center bg-brand-charcoal text-brand-white">{item.icon}</span>
              <p className="font-display text-[16px] font-black uppercase leading-snug tracking-[-0.01em] text-ink">
                {item.problem}
              </p>
              <p className="text-[14px] leading-relaxed text-ink-muted">{item.solution}</p>
            </li>
          ))}
        </ul>

        <div className="mt-16 grid gap-6 border-t border-hairline pt-12 md:grid-cols-3">
          {CAPABILITIES.map((item) => (
            <div key={item.title} className="flex flex-col gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center border border-hairline text-accent">
                {item.icon}
              </span>
              <h3 className="text-[14px] font-bold uppercase tracking-[0.04em] text-ink">{item.title}</h3>
              <p className="text-[13px] leading-relaxed text-ink-muted">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
